export default "__VITE_PUBLIC_ASSET__727d7b6a__"